import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-job-highlight-item',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './job-highlight-item.component.html',
  styleUrls: ['./job-highlight-item.component.scss'],
})
export class JobHighlightItemComponent {
  @Input() icon: string = 'fa-info-circle'; // Default icon
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() valuesArray: string[] | undefined = [];
}
